module.exports = __webpack_public_path__ + "img/hotel_zwt.8fc1d7de.jpg";